import { Injectable } from '@angular/core';
import { EntityServicesBase, EntityServicesElements } from '@ngrx/data';
import { CLICommandsService } from './cli/cli-commands.service';
import { CLITemplatesService } from './cli/cli-templates.service';
import { ClientsService } from './clients/clients.service';
import { EventsService } from './events/events.service';
import { NodesService } from './nodes';
import { NotificationSettingsService } from './notifications/settings/notification-settings.service';
import { SelectSitesService, SitesService } from './sites';
import { TagsService } from './tags';
import { TasksService } from './tasks/tasks.service';
import { TeamService } from './team/team.service';
import { TeamsService } from './teams';
import { TeamMembersService } from './teams/members/team-members.service';
import { TeamSitesService } from './teams/sites/team-sites.service';

@Injectable()
export class CustomEntityServices extends EntityServicesBase {
  constructor(
    elements: EntityServicesElements,
    readonly sitesService: SitesService,
    readonly nodesService: NodesService,
    readonly teamsService: TeamsService,
    readonly teamMembersService: TeamMembersService,
    readonly teamSitesService: TeamSitesService,
    readonly teamService: TeamService,
    readonly clientsService: ClientsService,
    readonly tagsService: TagsService,
    readonly notificationSettingsService: NotificationSettingsService,
    readonly eventsService: EventsService,
    readonly tasksService: TasksService,
    readonly cliCommandsService: CLICommandsService,
    readonly cliTemplatesService: CLITemplatesService,
    readonly selectSitesService: SelectSitesService,
  ) {
    super(elements);
    this.registerEntityCollectionServices([
      sitesService,
      nodesService,
      teamsService,
      teamMembersService,
      teamSitesService,
      teamService,
      clientsService,
      tagsService,
      notificationSettingsService,
      eventsService,
      tasksService,
      cliCommandsService,
      cliTemplatesService,
      selectSitesService,
    ]);
  }
}
